import { Table } from '@tiptap/extension-table';
import {
   addColumn,
   addRow,
   cleanDeleteColumn,
   selectColumn,
   selectRow,
   selectTable,
   deleteRow,
   mergeCells,
} from './inline_table_commands';
import { inlinetableDecorations } from './inline_table_decorations_plugin';

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      tableRow: {
         selectRow: (rowIndex: number) => ReturnType;
         selectColumn: (columnIndex: number) => ReturnType;
         selectTable: () => ReturnType;
         insertTable: (options?: {
            rows?: number;
            cols?: number;
            withHeaderRow?: boolean;
         }) => ReturnType;
         addColumn: (columnIndex: number) => ReturnType;
         addColumnBefore: () => ReturnType;
         addColumnAfter: () => ReturnType;
         deleteColumn: () => ReturnType;
         addRow: (rowIndex: number) => ReturnType;
         addRowBefore: () => ReturnType;
         addRowAfter: () => ReturnType;
         deleteRow: () => ReturnType;
         deleteTable: () => ReturnType;
         mergeCells: () => ReturnType;
         splitCell: () => ReturnType;
         toggleHeaderColumn: () => ReturnType;
         toggleHeaderRow: () => ReturnType;
         toggleHeaderCell: () => ReturnType;
         mergeOrSplit: () => ReturnType;
         setCellAttribute: (name: string, value: any) => ReturnType;
         goToNextCell: () => ReturnType;
         goToPreviousCell: () => ReturnType;
         fixTables: () => ReturnType;
         setCellSelection: (position: { anchorCell: number; headCell?: number }) => ReturnType;
         cleanDeleteColumn: () => ReturnType;
      };
   }
}

export const InlineTable = Table.extend({
   addCommands() {
      return {
         ...this.parent?.(),
         selectRow,
         selectColumn,
         selectTable,
         cleanDeleteColumn,
         addRow,
         addColumn,
         deleteRow,
         mergeCells,
      };
   },
   addProseMirrorPlugins() {
      return [...(this.parent ? this.parent() : []), inlinetableDecorations(this.editor)];
   },
}).configure({
   resizable: true,
   cellMinWidth: 40,
});
